module.exports = __webpack_public_path__ + "static/media/no-image-available.587bc39c.png";